import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.shape({
  type: PropTypes.string,
  asset: PropTypes.shape({
    src: PropTypes.shape({
      full: PropTypes.string
    })
  })
}));
